import React from "react";

 function Error(){
    return(
        <div className="error">
            <h1>Page you are looking for was not found. Sorry.</h1>
        </div>
    )
}
export default Error;